import React from "react";
import banner from "../../assets/banner.png";
import banner2 from "../../assets/banner2.png";
import banner3 from "../../assets/banner3.jpg";
import d1 from "../../assets/donation/d1.png";
import d2 from "../../assets/donation/d2.png";
import d3 from "../../assets/donation/d3.png";
import d4 from "../../assets/donation/d4.png";
import DropDown from "../Util/DropDown";

import bg from "../../assets/bg.png";

const Home = () => {
	const s2 = "px-6 py-2 font-semibold text-base rounded-full group-hover:px-12 hover:px-20 group-hover:drop-shadow-2xl shadow-sm bg-blood z-30 text-white-900 hover:drop-shadow-md hover:opacity-80";

	const bloodDonationType = [
		{blood: "A+", donate: "A+, AB+", receive: "A+, A-, O+, O-"},
		{blood: "O+", donate: "O+, A+, B+, AB+", receive: "O+, O-"},
		{blood: "B+", donate: "B+, AB+", receive: "B+, B-, O+, O-"},
		{blood: "AB+", donate: "AB+", receive: "Everyone"},
		{blood: "A-", donate: "A+, A-, AB+, AB-", receive: "A-, O-"},
		{blood: "O-", donate: "Everyone", receive: "O-"},
		{blood: "B-", donate: "B+, B-, AB+, AB-", receive: "B-, O-"},
		{blood: "AB-", donate: "AB+, AB-", receive: "AB-, A-, B-, O-"},
	];
	const bloodDonationProcess = [
		{
			title: "Registration",
			img: d1,
			description:
				"During the registration process, donors provide essential personal information such as their name, contact details, and medical history. Additionally, they may be required to fill out forms or answer questions related to their eligibility to donate blood, ensuring the safety and suitability of their donation.",
		},
		{
			title: "Health Screening",
			img: d2,
			description: "Before donation, donors undergo health screening, including checks of blood pressure, temperature, and hemoglobin levels. They're also asked about recent travel, medications, and bloodborne disease risks.",
		},
		{
			title: "Donation",
			img: d3,
			description: "Donors, cleared for donation, give blood in a 10-15 minute process. Around one pint of blood is collected using sterile equipment. The process is supervised by trained medical staff to ensure donor safety.",
		},
		{
			title: "Impact",
			img: d4,
			description:
				"Donated blood is rigorously tested to ensure its safety. It's then stored and distributed to hospitals, where it's used in emergencies, surgeries, and medical treatments. Every donation can save up to three lives, making a significant impact on the community.",
		},
	];

	return (
		<div className="dark:text-white-900 relative">
			<div>
				<div className="relative h-full w-full">
					<img src={bg} alt="" className=" relative w-full h-full " />
					<div className="absolute z-10 inset-0  w-2/3 h-full mx-auto text-center top-1/4 p-4">
						<h1 className="text-red-600 font-[''] font-bold text-4xl">DONATE</h1>
						<h2 className="text-red  text-justify  text-[6.8rem]  leading-[5rem] mt-2 font-extrabold ">
							<center>YOUR BLOOD</center>
						</h2>
						<div className="w-4/5 mx-auto p-1 text-center relative">
							<p className="text-justify relative w-full mt-2 text-lg">
								<center>“The finest gesture one can make is to save life by donating Blood.”</center>
							</p>
						</div>
						<br></br>
						<br></br>
						<button className="text-gray-700 font-semibold mx-4 rounded inline-flex  ">
							<span className={s2}>{"REGISTER AS A DONOR"} &nbsp;</span>
						</button>
					</div>
				</div>
			</div>
			{/* <h1 className="font-bold text-center text-blood my-4 text-xl">Explore Blood Donation</h1>

			<div className="flex px-20">
				<div>
					<img src={banner3} width="100%" alt="" />
					<p className="text-center">
						<code>After giving blood, your body begins the remarkable process of replenishing its supply. This renewal stimulates the production of fresh blood cells, promoting overall well-being and vitality.</code>
					</p>
				</div>
				<div>
					<table className="w-max" cellPadding={5}>
						<tr>
							<td colSpan={3} className="border bg-blood text-white-900 text-center font-bold">
								Blood Type Compatibility Matrix
							</td>
						</tr>
						<tr>
							<th className="border w-max text-lg text-center">Blood Type</th>
							<th className="border w-max text-lg text-center">Compatible Donors</th>
							<th className="border w-max text-lg text-center">Compatible Recipients</th>
						</tr>
						{bloodDonationType.map(e => {
							return (
								<tr>
									<td className="border w-max text-lg text-center">{e.blood}</td>
									<td className="border w-max text-lg text-center">{e.donate}</td>
									<td className="border w-max text-lg text-center">{e.receive}</td>
								</tr>
							);
						})}
					</table>
				</div>
			</div> */}
			<p className="text-4xl  font-bold text-blood text-center mt-5 mb-5 px-10 py-10">Blood Donation Process</p>
			<div className="grid grid-cols-2 place-items-center">
				{bloodDonationProcess.map((e, i) => (
					<div className="border-metal shadow-md rounded-lg overflow-hidden max-w-[90%] select-none grid grid-cols-2">
						<div>
							<img src={e.img} draggable={false} width="100%" alt="" />
						</div>
						<div className="m-4">
							<h1 className="font-bold text-lg text-midnight dark:text-white-900">
								{i + 1} - {e.title}
							</h1>
							<p className="text-justify">{e.description}</p>
						</div>
					</div>
				))}
			</div>
			<br />
			<div className="w-full bg-blood text-white-900 h-max text-sm text-center font-bold">
				<code>Made with ❤️ by Akshit Sharma</code>
			</div>
		</div>
	);
};

export default Home;
